var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.orderInfo.length<='0')?_c('van-empty',{attrs:{"description":"当前没有正在服务中的订单"}}):_c('Orderlist',{attrs:{"orderInfo":_vm.orderInfo,"total":_vm.total,"formData":_vm.formData}}),_vm._v(" "),_c('Tabbar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee253dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/service.vue
// module id = null
// module chunks = 